export default __webpack_public_path__ + "static/media/react-router.8267fc2e.svg";